<template>
  <div class="workDetails" >
    <bq-header />
    <div class="content-wrapper">
      <div class="work-title wrapper">
        <div class="work-title-detail">
          <div class="item-txt clearfix">
            <div style="z-index: 3; position: relative">
              {{ detail.typeTitle }}
            </div>
            <!-- {{detail.typeEName}}
               /  {{detail.typeName}} -->
            <img :src="titlelogo" alt="" style="z-index: 2" />
          </div>
        </div>
      </div>
      <div class="work-main wrapper clearfix">
        <div class="work-main-left">
          <div class="swiper-container22" style="height: 826px">
            <swiper
              class="swiper gallery-top"
              :options="swiperOptionTop"
              ref="swiperTop"
              v-if="bigImg.length"
            >
              <swiper-slide
                class="slide-1"
                v-for="(item, index) in bigImg"
                :key="'10' + index"
              >
                <div
                  class="swiper-slide-item"
                  style="height: 100%; background-color: #f9f9f9"
                >
                  <div class="img-wrapper img-animate">
                    <img
                      :src="item"
                      alt=""
                      style="height: 100%; object-fit: contain; margin: 0 auto"
                    />
                  </div></div
              ></swiper-slide>
              <!-- <swiper-slide class="slide-1" style="background: red"
                >1</swiper-slide
              >
              <swiper-slide class="slide-2" style="background: blue"
                >2</swiper-slide
              >
              <swiper-slide class="slide-3" style="background: yellow"
                >3</swiper-slide
              >
              <swiper-slide class="slide-4" style="background: brown"
                >4</swiper-slide
              >
              <swiper-slide class="slide-5" style="background: green"
                >5</swiper-slide
              >
              <swiper-slide class="slide-6" style="background: yellow"
                >6</swiper-slide
              >
              <swiper-slide class="slide-7" style="background: blue"
                >7</swiper-slide
              > -->

              <!-- <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                           <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
            </swiper>
            <div style="height: 24px"></div>
            <swiper
              class="swiper gallery-thumbs"
              :options="swiperOptionThumbs"
              ref="swiperThumbs"
              v-if="miniImg.length"
            >
              <swiper-slide
                class="slide-1"
                :class="active == index ? 'active' : ''"
                v-for="(item, index) in miniImg"
                :key="'10' + index"
              >
                <div class="swiper-slide-item">
                  <img
                    :src="item"
                    alt=""
                    style="width: 100%; height: 100%"
                    class="pointer"
                  /></div
              ></swiper-slide>
              <!-- <swiper-slide class="slide-1">
                <div class="swiper-slide-item" style="background: red"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: blue"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: yellow"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: brown"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: green"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: yellow"></div
              ></swiper-slide>
              <swiper-slide class="slide-1"
                ><div class="swiper-slide-item" style="background: blue"></div
              ></swiper-slide> -->
              <div
                class="swiper-scrollbar"
                slot="scrollbar"
                style="left: 0%; width: 100%; display: block !important"
              ></div>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>

            <!-- <div class="centerDiv">
              <div class="thumb-example"></div>
            </div> -->
          </div>
        </div>
        <div class="work-main-right">
          <div class="work-main-title">
            {{ detail.workName }}
            <!-- 美术作品名称美术作品名称美术作品名称美术作品 -->
          </div>
          <div class="work-main-title2" style="margin-bottom: 42px">
            {{ detail.workEname }}
            <!-- meishuzuopinmingchengmeishuzuopin -->
          </div>
          <div class="work-main-detail">
            <div class="work-detail-author clearfix">
              <div class="detail-left">著作权人</div>
              ：
              <div class="detail-right">
                <!-- 王依依、王依依、王依依、王依依、王依依、王依依、王依依、王依依、王依依、王依依 -->
                {{ detail.roleNames }}
              </div>
            </div>

            <div class="work-detail-author clearfix">
              <div class="detail-left">登记日期</div>
              ：
              <div class="detail-right">{{ detail.time }}</div>
            </div>
            <div class="work-detail-author clearfix">
              <div class="detail-left">作品类别</div>
              ：
              <div class="detail-right">{{ detail.typeName||detail.typeEName }}</div>
            </div>

            <div class="work-detail-author clearfix">
              <div class="detail-left">登记号</div>
              ：
              <div class="detail-right">{{ detail.code }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="work-other wrapper">
        <div class="work-other-title">区块链存证</div>

        <div class="work-other-main">
          <div class="work-main-item">
            <div class="work-main-title"></div>
            <div class="work-main-desc"></div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">浏览器地址：</div>
            <div class="work-main-desc">{{ obj.watchId || "" }}</div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">存证的区块高度：</div>
            <div class="work-main-desc">{{ obj.localHeight || "" }}</div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">交易ID：</div>
            <div class="work-main-desc">{{ obj.dealId || "" }}</div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">存证时间：</div>
            <div class="work-main-desc">{{ obj.saveTime2 || "" }}</div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">链接地址：</div>
            <div class="work-main-desc">{{ obj.netAddr || "" }}</div>
          </div>
          <div class="work-main-item">
            <div class="work-main-title">区块HASH：</div>
            <div class="work-main-desc">{{ obj.localHash || "" }}</div>
          </div>
        </div>
      </div>
      <bq-footer style="margin-top: 86px"></bq-footer>
    </div>
  </div>
</template>

<script>
import bqHeader from "@/view/V2/components/header.vue";
// import bqFooter from "@/view/V2/components/footer.vue";
import bqFooter from "@/components/tail";
import titlelogo from "@/assets/V2/title_logo.png";
import swiper from "vue-awesome-swiper/src/swiper.vue";
import swiperSlide from "vue-awesome-swiper/src/slide.vue";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    bqHeader,
    bqFooter,
    swiper,
    swiperSlide,
  },
  mounted() {
    this.$nextTick(() => {
      // const swiperTop = this.$refs.swiperTop.swiper;
      // const swiperThumbs = this.$refs.swiperThumbs.swiper;
      // this.eell = swiperTop;
      // console.log(this.$refs);
      // swiperTop.controller.control = swiperThumbs;
      // swiperThumbs.controller.control = swiperTop;
    });
  },

  async created() {
    // 初始化轮播图配置
    this.setOption1();
    this.setOption2();

    // this.miniImg=[this.titlelogo,this.titlelogo,this.titlelogo]
    // this.bigImg = [this.titlelogo,this.titlelogo,this.titlelogo]
    // return
    // {
    //   watchId:'',
    //              localHeight:'',
    //              dealId:'',
    //              saveTime:'',
    //              netAddr:'',
    //              localHash:''
    // }
    if (this.$route.query.id) {
      var id = this.$route.query.id;
      // watchId浏览器地址
      // dealId交易
      // localHash区块hash
      // localHeight区块高度
      // netAddr链接地址
      // saveTime存正时间
      // "08d2f90099b14548b9a1f36ead44c4dd",
      this.$getHttp("pc/tShow/findLocal", {
        workId: this.$route.query.workId
      }).then((data) => {
        if (data.success && data.list) {
          // var target = data.list
          // this.watchId = target.watchId
          // this.watchId = target.watchId

          var time = new Date(data.list.saveTime);
          var y = time.getFullYear();
          var m = time.getMonth() + 1;
          var d = time.getDate();
          var h = time.getHours();
          var mm = time.getMinutes();
          var s = time.getSeconds();
          data.list.saveTime2 =
            y +
            "-" +
            this.add0(m) +
            "-" +
            this.add0(d) +
            " " +
            this.add0(h) +
            ":" +
            this.add0(mm) +
            ":" +
            this.add0(s);

          this.recover(this.obj, data.list);
          console.log(this.obj, 22);
        }
      });
      this.$getHttp("pc/tType/getOne", { id: id }).then((data) => {
        var title = "123";
        if (data.data.typeEName && data.data.typeName) {
          title = data.data.typeEName + "/" + data.data.typeName;
        } else {
          title = data.data.typeEName
            ? data.data.typeEName
            : data.data.typeName;
        }

        this.detail = {
          workName: data.data.workName,
          workEname: data.data.workEname,
          roleNames: data.data.owner,
          time: data.data.time,
          typeTitle: title,
          typeName: data.data.typeName,
          typeEName:data.data.typeEName.toUpperCase(),
          code: data.data.code,
        };

        var miniImg = data.data.dimg == "" ? [] : data.data.dimg.split("|");
        var bigImg = data.data.dimg == "" ? [] : data.data.dimg.split("|");
        if (miniImg.length) {
          this.miniImg = miniImg.map((item) => {
            return this.$baseUrl + item;
          });
          // this.miniImg = [...this.miniImg,...this.miniImg]
        }

        // console.log(this.miniImg.length)
        if (bigImg.length) {
          this.bigImg = bigImg.map((item) => {
            return this.$baseUrl + item;
          });
        }
        console.log(this.$baseUrl);
        console.log(bigImg);

        this.$nextTick(() => {
          const swiperTop = this.$refs.swiperTop.swiper;
          const swiperThumbs = this.$refs.swiperThumbs.swiper;
          this.eell = swiperTop;
        });

        // console.log(this.miniImg)
        //  console.log(data.data.dimg)
        //   console.log(this.miniImg.length)
      });
    }
  },
  data() {
    return {
      obj: {
        watchId: "",
        localHeight: "",
        dealId: "",
        saveTime: "",
        saveTime2: "",
        netAddr: "",
        localHash: "",
      },
      miniImg: [],
      bigImg: [],
      eell: {},
      detail: {},
      defaultImg:
        "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
      input2: "",
      titlelogo: titlelogo,

      carouselList: [
        //图片
        { path: require("../../assets/error.png") },
        { path: require("../../assets/success.png") },
        { path: require("../../assets/time.png") },
        { path: require("../../assets/zhengshu.jpg") },
        { path: require("../../assets/register1.png") },
      ],
      swiperOptionTop: {},
      swiperOptionThumbs: {},
      active: 0,
    };
  },
  methods: {
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    setOption1() {
      this.swiperOptionTop = {
        // loopedSlides: 7, // looped slides should be the same
        spaceBetween: 10,
        allowTouchMove: false,
      };
    },
    setOption2() {
      var that = this;
      this.swiperOptionThumbs = {
        // loopedSlides: 7, // looped slides should be the same
        spaceBetween: 14,
        // centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        freeMode: true,
        freeModeMomentumVelocityRatio: 2,
        // slideToClickedSlide: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
          snapOnRelease: false,
          // dragSize: 200,
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   type: "progressbar",
        // },
        on: {
          click: function (e) {
            console.log("你点了Swiper");
            // alert("你点了Swiper");
            // alert("你点了Swiper"+this.activeIndex);
            // clickedIndex
            // this.snapIndex=this.clickedIndex
            // this.activeIndex=this.clickedIndex
            this.slideTo(this.clickedIndex - 1, 300, false);
            that.eell.slideTo(this.clickedIndex, 300, false);
            that.active = this.clickedIndex;
            // console.log(this)
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0%;
  // background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

img,
.item-txt-lr,
.mask {
  transition: all 0.5s;
}
@keyframes show {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
@keyframes close {
  0% {
    height: 100;
  }
  100% {
    height: 0%;
  }
}
.img-animate:hover img {
  transform: scale(1.05);
}
.img-animate:hover .mask {
  // animation: show 300ms;
  // animation-fill-mode: forwards;
  height: 100%;
}
.img-animate:hover .list-item-txt {
  opacity: 1;
}
.img-animate .list-item-txt {
  opacity: 0;
}

.img-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
  cursor: pointer;
}
.img-wrapper.swiper-img {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
}
.pointer {
  cursor: pointer;
}
.workDetails {
  position: relative;
  min-width: 1440px;
}
.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.bqv2-index {
  position: relative;
  overflow: hidden;
  color: #333333;
}
.wrapper {
  width: 1200px;
  margin: 0 auto;
}
.content-wrapper {
  position: absolute;
  left: 0;
  top: 100px;
  z-index: 10;
  // margin-top: -620px;
  // min-height: 100vh;
  width: 100%;
  background-color: #fff;
  // margin-bottom: 179px;
  .work-title {
    // height: 148px;
    box-sizing: border-box;
    padding-top: 40px;
    .item-txt {
      float: left;
      margin: 30px 0;
      height: 48px;
      max-width: 90%;
      width: auto;
      font-size: 34px;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
      position: relative;
      img {
        position: absolute;
        right: -27px;
        top: -7px;
        width: 70px;
        height: 64px;
        vertical-align: middle;
      }
    }
  }
  .work-main {
    width: 1200px;
    .work-main-left {
      float: left;
      width: 626px;
      .swiper-container22 {
        width: 626px;
        height: 626px;
        // border-radius: 28px 28px 28px 28px;
        // overflow: hidden;
        .swiper-container {
          // width: 626px;
          // height: 626px;
        }
      }
      .swiper-container33 {
        margin-top: 22px;
        height: 146px;
        width: 626px;
        .swiper-container {
          // width: 100%;
          // height: 100%;
        }
      }
    }
    .work-main-right {
      width: 513px;
      float: right;
      .work-main-title {
        padding: 15px 0 0 2px;

        // height: 40px;
        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 40px;

        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .work-main-title2 {
        padding: 15px 0 0 2px;

        font-size: 28px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 400;

        color: #747474;
        line-height: 40px;
        word-break: break-all;
      }
      .work-detail-author {
        color: #333333;
        margin-bottom: 12px;
      }
      .detail-left {
        float: left;
        width: 72px;
        text-align: justify;
        text-align-last: justify;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .detail-right {
        width: 425px;
        float: right;
        word-break: break-word;
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        // line-height: 1px;
      }
    }
  }
  .work-other {
    margin-top: 44px;
    margin-bottom: 45px;
    // width: 1200px;
    // height: 564px;
    background: linear-gradient(134deg, #bb7cc6 0%, #763bfa 51%, #387cd9 100%);
    border-radius: 28px 28px 28px 28px;
    opacity: 1;
    box-sizing: border-box;
    padding: 30px 36px 40px 36px;
    overflow: hidden;
    .work-other-title {
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
    }
    .work-other-main {
      margin-top: 30px;
      color: #ffffff;
      // width: 1016px;
      font-size: 18px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      // line-height: 0px;

      .work-main-item {
        margin-bottom: 26px;
        &:last-child {
          margin-bottom: 0px;
        }
        .work-main-title {
          position: relative;
          box-sizing: border-box;
          padding-left: 13px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0px;
            top: 3px;
            width: 5px;
            height: 18px;
            background-color: #fff;
            border-radius: 3px;
          }
        }
        .work-main-desc {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }
    }
  }
}

.centerDiv {
  width: 900px;
  height: 800px;
  position: absolute;
  left: 510px;
  top: 200px;
}

.thumb-example {
  height: 580px;
  background-color: transparent;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

// .slide-1 {
//   background-image: url('../../../../static/img/dandan/g1.jpg');
//  }
// .slide-2 {
//   background-image: url('../../../../static/img/dandan/g2.jpg');
//  }
// .slide-3 {
//   background-image: url('../../../../static/img/dandan/g3.jpg');
//  }
// .slide-4 {
//   background-image: url('../../../../static/img/dandan/g4.jpg');
//  }
// .slide-5 {
//   background-image: url('../../../../static/img/dandan/g5.jpg');
//  }

.gallery-top {
  height: 626px;
  width: 100%;
  border-radius: 28px 28px 28px 28px;
  overflow: hidden;
}
.gallery-thumbs {
  // border-radius: 28px 28px 0  0;
  //       overflow: hidden;
  width: 100%;
  height: 176px;
  box-sizing: border-box;
  padding-bottom: 30px;
  // padding: 10px 0;
  .swiper-slide {
    width: 146px;
    height: 176px;
    opacity: 0.4;
    .swiper-slide-item {
      width: 146px;
      height: 146px;
      border-radius: 16px 16px 16px 16px;
      overflow: hidden;
    }
  }
}

// .gallery-thumbs .swiper-slide-active {
//   opacity: 1;
// }
.gallery-thumbs .active {
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/view/V2/workDetails.vue